
export class SearchOpeBiCriteria {

    motCle!: string;
    region!: string[];
    codesDepartement!: string[];
    villes!: string[];
    //Appartement maison
    codeCategories!: BigInteger[];
    //T1 T2 ....
    codeTypologie!: BigInteger[];
    //Tyepologie
    nbrPieces!: number[];
    etage!: number;
    surfaceExterne!: boolean;
    budget!: number[];
    nbmoisLivraison!: number[];
    codeTva!: string[];
    statutLot!: BigInteger[];

     constructor(args: SearchOpeBiCriteria = {
         motCle: "",
         region: [],
         codesDepartement: [],
         villes: [],
         codeCategories: [],
         codeTypologie: [],
         nbrPieces: [],
         etage: 0,
         surfaceExterne: false,
         budget: [],
         nbmoisLivraison: [],
         codeTva: [],
         statutLot: []
     }){
        this.motCle =args.motCle;
        this.region = args.region;
        this.codesDepartement=args.codesDepartement;
        this.villes=args.villes;
        this.codeCategories = args.codeCategories;
        this.codeTypologie = args.codeTypologie;
        this.nbrPieces = args.nbrPieces;
        this.etage = args.etage;
        this.surfaceExterne = args.surfaceExterne;
        this.budget= args.budget;
        this.nbmoisLivraison = args.nbmoisLivraison;
        this.codeTva = args.codeTva;
        this.statutLot = args.statutLot;
     }

}


